export default "__VITE_ASSET__BXqjger0__"